import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Customers API
export const customersAPI = {
  getAll: (search = '') => api.get(`/customers?search=${search}`),
  getById: (id) => api.get(`/customers/${id}`),
  getDetails: (id) => api.get(`/customers/${id}/details`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
};

// Measurements API
export const measurementsAPI = {
  getAll: (customerId = '') => api.get(`/measurements${customerId ? `?customer_id=${customerId}` : ''}`),
  getById: (id) => api.get(`/measurements/${id}`),
  create: (data) => api.post('/measurements', data),
  update: (id, data) => api.put(`/measurements/${id}`, data),
  delete: (id) => api.delete(`/measurements/${id}`),
};

// Orders API
export const ordersAPI = {
  getAll: (status = '') => api.get(`/orders${status ? `?status=${status}` : ''}`),
  getById: (id) => api.get(`/orders/${id}`),
  create: (data) => api.post('/orders', data),
  update: (id, data) => api.put(`/orders/${id}`, data),
  delete: (id) => api.delete(`/orders/${id}`),
  getStats: () => api.get('/orders/stats/summary'),
};

export default api;

